<template>
    <div class="course">
        <ul class="course_info">
            <li>
                <img src="@/assets/images/historyCourse.png" alt="" @click="getVideo(465)">
            </li>
            <li>
                <img src="@/assets/images/englishCourse.png" alt="" @click="getVideo(357)">
            </li>
            <li>
                <img src="@/assets/images/galleryCourse.png" alt="" @click="getVideo(429)">
            </li>
            <li>
                <img src="@/assets/images/LouvreCourse.png" alt="" @click="getVideo(329)">
            </li>
            <li>
                <img src="@/assets/images/MentionCourse.png" alt="" @click="getVideo(395)">
            </li>
            <li>
                <img src="@/assets/images/orsayCourse.png" alt="" @click="getVideo(235)">
            </li>
            <li>
                <img src="@/assets/images/LouvreCourse.png" alt="" @click="getVideo(297)">
            </li>
            <li>
                <img src="@/assets/images/starCourse.png" alt=""  @click="getVideo(548)">
            </li>                                                                                    
        </ul>
        <div>
            <van-popup v-model="video" closeable   :style="{ height: '30%' }"  class="popup-video" @close="closeVideo">
                <video id="vide" class="paly"  :src="video_url"  controls="controls" ref= "myVideo" controlsList="nodownload" playsinline="true" webkit-playsinline="true" x5-playsinline="true"> </video>
            </van-popup>      
        </div>
        <Comment></Comment>
    </div>
</template>

<script type="text/ecmascript-6">
import Comment from '@/components/Comment.vue'
import {baseApiModules} from '@/api'
export default {
 components: {
    Comment
},
 props: {},
 data () {
 return {
    video:false,
    video_url:'',
    s_course_id:0
 };
 },
 watch: {

},
 computed: {},
 methods: {

        getVideo(s_course_id) {
            this.video = true
            this.getWebVideoUrl(s_course_id)
        },
        stopPlay(){
             this.video = false
        },
        getWebVideoUrl(s_course_id){

            let params = {
                s_course_id: s_course_id
            }

            baseApiModules.getWebVideo(params).then(res => {
                if (res.code === 0) {
                    this.video_url = res.data

                    let _this = this
                    setTimeout(function(){
                        _this.$refs.myVideo.play()
                    })
                } else {

                }
                }).catch(err => {
                    console.log(err)
            })
        },
        closeVideo() {
            // var vide=document.getElementById("vide");
            // console.log()
            //     if(vide.paused){
            //         vide.play();
            //     }else if(vide.play()){
            //         vide.pause();
            //     }
            this.video = false
            this.video_url = ''
        },

},
 mounted () {}
};
</script>
<style>
.course{
    background-color: #eff3f4;
    /* height: 100%; */
}
.course_info li img{
    padding: 0.5rem 0 0 0;
    margin: 0 auto;
    width: 6.50rem;
    height: 6.54rem;
}
.course_info li:last-child img{
    padding-bottom: 0.55rem;

}
.paly{
    width: 7rem;
    height: 100%;
}
.popup-video{
    height: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/course/course.vue